import { render } from "./Parameter.vue?vue&type=template&id=2a461ca1&scoped=true"
import script from "./Parameter.vue?vue&type=script&lang=js"
export * from "./Parameter.vue?vue&type=script&lang=js"

import "./Parameter.vue?vue&type=style&index=0&id=2a461ca1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a461ca1"]])

export default __exports__